import React from 'react';
import Strips from '../../../styles/staticAssets/images/Strips.svg';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';
import useStyleScripts from 'common/custom-hooks/useStyleScripts';

const TermsOfUseHeader = props => {
  const { headerData: { description, title } = {}, userParams } = props;
  const CustomStyledDiv = useStyleScripts(STYLE_SCRIPT_CONST?.TERMS_OS_USE_STYLES);

  return (
    CustomStyledDiv && (
      <CustomStyledDiv className={`terms-header-container${userParams?.localized ? ' localized' : ''}`}>
        <img src={Strips} className='terms-icon' alt=' ' />
        <h4 className='terms-header'>{title}</h4>
        <div className='terms-and-condition-data'>{description}</div>
      </CustomStyledDiv>
    )
  );
};

export default TermsOfUseHeader;
